import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TransactionForm from '../components/TransactionForm';
import ResultDisplay from '../components/ResultDisplay';
import useAccountingApi from '../../../../hooks/useAccountingApi';

const FinancialActivities = () => {
  const [formData, setFormData] = useState({
    description: '',
    amount: '',
    transactionType: '',
    counterparty: '',
    terms: ''
  });
  const [showExamples, setShowExamples] = useState(true);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const { loading, error, getSuggestion, submitFeedback } = useAccountingApi();
  const [result, setResult] = useState(null);

  const examples = [
    '은행 대출금 상환 - 3년 만기',
    '거래처에 단기대여금 지급',
    '정기예금 가입 - 1년 만기'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await getSuggestion({
        ...formData,
        category: 'FINANCE',
        transactionType: formData.transactionType
      });
      setResult(data);
    } catch (err) {
      console.error('Error:', err);
    }
  };

  const handleFeedback = async (isHelpful) => {
    try {
      await submitFeedback({
        category: 'FINANCE',
        isHelpful,
        suggestion: result,
        userInput: formData
      });
      setFeedbackSubmitted(true);
    } catch (err) {
      console.error('Feedback Error:', err);
    }
  };

  const handleReset = () => {
    setFormData({
      description: '',
      amount: '',
      transactionType: '',
      counterparty: '',
      terms: ''
    });
    setResult(null);
    setFeedbackSubmitted(false);
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-8">
        <div className="flex items-center mb-4">
          <Link to="/services" className="text-blue-600 hover:text-blue-700">
            ← 서비스 선택으로 돌아가기
          </Link>
        </div>
        <h1 className="text-2xl font-bold text-gray-900">재무 활동 분개</h1>
        <p className="mt-2 text-gray-600">
          차입금, 대여금, 예금 등 재무 활동과 관련된 분개를 추천해드립니다.
        </p>
      </div>

      <div className="space-y-8">
        {!result && (
          <div className="bg-white rounded-lg shadow-lg p-6">
            <TransactionForm
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleSubmit}
              loading={loading}
              showExamples={showExamples}
              setShowExamples={setShowExamples}
              examples={examples}
              additionalFields={[
                {
                  name: 'transactionType',
                  label: '거래 유형',
                  type: 'select',
                  options: [
                    { value: 'loan', label: '차입/상환' },
                    { value: 'lending', label: '대여/회수' },
                    { value: 'deposit', label: '예금/적금' },
                    { value: 'investment', label: '투자' }
                  ]
                },
                {
                  name: 'counterparty',
                  label: '거래처',
                  type: 'text',
                  placeholder: '거래 상대방을 입력해주세요'
                },
                {
                  name: 'terms',
                  label: '거래 조건',
                  type: 'textarea',
                  placeholder: '만기, 이자율 등 주요 조건을 입력해주세요'
                }
              ]}
            />
          </div>
        )}

        {error && (
          <div className="p-4 bg-red-100 text-red-700 rounded-lg">
            {error}
          </div>
        )}

        {result && (
          <div className="space-y-6">
            <ResultDisplay
              result={result}
              onFeedback={handleFeedback}
              feedbackSubmitted={feedbackSubmitted}
            />
            <div className="flex justify-center">
              <button
                onClick={handleReset}
                className="px-6 py-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 transition-colors"
              >
                새로운 분개 추천받기
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FinancialActivities; 